export default __webpack_public_path__ + "static/media/doodle2gather.a602eee5.png";